import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { BrandProvider } from '@/contexts/BrandContext'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Key, Settings, Activity, FileText, Database, Palette } from 'lucide-react'
import { DefaultApiKeysSection } from '@/components/clients/DefaultApiKeysSection'
import { ActivityLogsSection } from '@/components/ActivityLogsSection'
import { ApiDocumentationTab } from '@/components/global-settings/ApiDocumentationTab'
import { PropertiesTab } from '@/components/global-settings/PropertiesTab'
import { BrandGuidelinesTab } from '@/components/global-settings/BrandGuidelinesTab'

export default function GlobalSettings() {
  return (
    <BrandProvider>
      <NewAppLayout>
        <div className="max-w-6xl mx-auto space-y-6">
          {/* Header */}
          <div className="flex items-center gap-3 mb-8">
            <Settings className="h-8 w-8 text-primary" />
            <div>
              <h1 className="text-3xl font-bold text-foreground">Global Settings</h1>
              <p className="text-muted-foreground">Manage platform-wide configurations and settings</p>
            </div>
          </div>

          {/* Settings Tabs */}
          <Tabs defaultValue="api" className="w-full">
            <TabsList className="grid w-full grid-cols-5 lg:w-fit">
              <TabsTrigger value="api" className="flex items-center gap-2">
                <Key className="h-4 w-4" />
                API Settings
              </TabsTrigger>
              <TabsTrigger value="docs" className="flex items-center gap-2">
                <FileText className="h-4 w-4" />
                API Docs
              </TabsTrigger>
              <TabsTrigger value="properties" className="flex items-center gap-2">
                <Database className="h-4 w-4" />
                Properties
              </TabsTrigger>
              <TabsTrigger value="brand" className="flex items-center gap-2">
                <Palette className="h-4 w-4" />
                Brand Guidelines
              </TabsTrigger>
              <TabsTrigger value="logs" className="flex items-center gap-2">
                <Activity className="h-4 w-4" />
                Activity Logs
              </TabsTrigger>
            </TabsList>

            <TabsContent value="api" className="space-y-6">
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2 text-xl">
                    <Key className="h-6 w-6" />
                    Default API Keys
                  </CardTitle>
                  <p className="text-muted-foreground">
                    Configure fallback API keys for OutboundBuddy services. These keys are used when no client-specific keys are available.
                  </p>
                </CardHeader>
                <CardContent>
                  <DefaultApiKeysSection isEditing={true} />
                </CardContent>
              </Card>
            </TabsContent>

            <TabsContent value="properties" className="space-y-6">
              <PropertiesTab />
            </TabsContent>

            <TabsContent value="brand" className="space-y-6">
              <BrandGuidelinesTab />
            </TabsContent>

            <TabsContent value="docs" className="space-y-6">
              <ApiDocumentationTab />
            </TabsContent>

            <TabsContent value="logs" className="space-y-6">
              <ActivityLogsSection />
            </TabsContent>
          </Tabs>
        </div>
      </NewAppLayout>
    </BrandProvider>
  )
}
